import React, { useState, useEffect } from 'react'

import { MultiDropDownSelect } from '../../../../../components/dashboard/TalentPool/DropdownSelect'

import Slider from '../../../../../components/dashboard/TalentPool/Assessments/components/Slider'

import Flex from '../../../../../components/layouts/Flex'
import { P } from '../../../../../style/Typography.style'

import axiosInstance from '../../../../../services/config/AxiosIntance'

const SkillLevelSelector = ({
  professionalHeadlineIds,
  technicalSkills,
  onChange,
  className,
  errorMessage,
}) => {
  const [skillList, setSkillList] = useState([])

  useEffect(() => {
    if (professionalHeadlineIds) {
      axiosInstance
        .get(
          `/technical-skills?professionalHeadline_id=${professionalHeadlineIds}`
        )
        .then((res) => {
          const formattedSkills = res?.data?.resp?.map((e) => ({
            label: e?.skills,
            value: e?.id,
            experience: 1,
          }))
          setSkillList(formattedSkills)
        })
    }
  }, [professionalHeadlineIds])

  const handleSliderChanged = (skillName, value) => {
    const updatedSkills = technicalSkills?.map((e) => {
      if (e?.label === skillName) return { ...e, experience: value }

      return e
    })

    onChange('technicalSkills', updatedSkills)
  }

  return (
    <>
      <MultiDropDownSelect
        setSelectedOption={(e) => onChange('technicalSkills', e)}
        selectedOption={technicalSkills}
        options={skillList}
        title="Technical Skills"
        placeholder="Select Technical Skills"
        className={className}
        errorMessage={errorMessage}
      />

      {technicalSkills?.length > 0 &&
        technicalSkills?.map((skill, skillIndex) => (
          <Flex key={skillIndex} items="center">
            <P width="50%">{skill?.label}</P>
            <Slider
              containerWidth="100%"
              id={skillIndex}
              value={parseInt(skill?.experience)}
              onChange={(e) =>
                handleSliderChanged(skill?.label, e.target.value)
              }
              min={1}
              max={5}
              labels={{
                1: 'Beginner',
                2: 'Novice',
                3: 'Skilled',
                4: 'Experienced',
                5: 'Expert',
              }}
            />
          </Flex>
        ))}
    </>
  )
}

export default SkillLevelSelector
